function AccountModalController(accountService, toasterService, eventService, userService, __env) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.isCurrentUser = ctrl.resolve.currentUser;
    ctrl.edit = ctrl.resolve.type === 'edit';
    ctrl.view = ctrl.resolve.type === 'view';
    ctrl.userGroups = angular.copy(ctrl.resolve.userGroups);
    ctrl.hasLoginMT = userService.hasLoginMT();

    if (ctrl.edit || ctrl.view) {
      ctrl.account = angular.copy(ctrl.resolve.account);
    } else {
      ctrl.account = {
        userGroups: [],
      };
    }
    processUserGroups();
  };

  const processUserGroups = () => {
    if (!ctrl.account.userGroups || !ctrl.userGroups) return;
    ctrl.userGroups.map(g => {
      ctrl.account.userGroups.forEach(group => {
        if (g.id === group.id) {
          g.checked = true;
          return false;
        }
      });
    });
  };

  ctrl.checkGroup = group => {
    const checked = Boolean(ctrl.account.userGroups.find(g => g.id === group.id));

    if (checked) {
      ctrl.account.userGroups = ctrl.account.userGroups.filter(g => g.id !== group.id);
    } else {
      if (group.name.includes('PIS')) {
        // Prevent multiple PIS groups from being checked.
        // User can only have one PIS-group.
        ctrl.account.userGroups = ctrl.account.userGroups.filter(g => !g.name.includes("PIS"));
      }
      ctrl.account.userGroups.push({id: group.id, name: group.name});
    }
  };

  ctrl.create = () => {
    accountService.create(ctrl.account).then(
      function() {
        toasterService.success('toaster.add-account', 'toaster.add-account-successful');
        eventService.trigger('accounts.update');
        ctrl.close();
      },
      function() {
        toasterService.error('toaster.add-account', 'toaster.add-account-failure');
      }
    );
  };

  ctrl.update = () => {
    Promise.all([
      userService.changePin(ctrl.account.pin.new),
    ]).then(
      function() {
        toasterService.success('toaster.edit-account', 'toaster.edit-account-successful');
        eventService.trigger('accounts.update');
        if (ctrl.isCurrentUser) {
          userService.update();
        }
        ctrl.close();
      },
      function() {
        toasterService.error('toaster.edit-account', 'toaster.edit-account-failure');
      }
    );
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('users.module')
  .controller('AccountModalController', AccountModalController);
